// src/modules/auth/pages/LoginPage.tsx
import React from "react";
import { Box } from "@mui/material";
import { LoginForm } from "../components/LoginForm";
import { useError } from "../../../errors/useError";
import { useAuth } from "../hooks/useAuth";

export const LoginPage: React.FC = () => {
  const { login } = useAuth();
  const { throwError } = useError();
  const [isLoading, setIsLoading] = React.useState(false);

  const handleSubmit = async (values: { email: string; password: string }) => {
    try {
      setIsLoading(true);
      await login(values.email, values.password);
    } catch (error) {
      throwError({
        name: "AuthError",
        message: error instanceof Error ? error.message : "Login failed",
        type: "AUTHENTICATION",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        minWidth: "100vw",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: "background.default",
      }}
    >
      <LoginForm onSubmit={handleSubmit} isLoading={isLoading} />
    </Box>
  );
};
